module.exports = __webpack_public_path__ + "static/dashboard-premium-e4fe2f224baf3cbce8c9596a66385271.png";